import { Button, Group, Paper } from "@mantine/core"
import uniq from "lodash/uniq"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { UserLine } from "@/components/people"
import { useAPIResource, useAuth } from "@/hooks"
import type { TSurveyAnswer, TSurveyQuestion } from "@/types"
import { userAPI } from "@/utils"
import { QuestionAnswer } from "./answers"

type TProps = {
  answers: TSurveyAnswer[]
  questions: TSurveyQuestion[]
}

export function UserSessionDetailsFeedback({ answers, questions }: TProps) {
  const { t } = useTranslation()
  const { user } = useAuth()

  // Get the respondent's peer answers
  const [peerIdx, setPeerIdx] = useState(0)
  const peerIds = uniq(answers.map((a) => a.peer_id).filter((id) => id))

  const { data: peer } = useAPIResource(userAPI, { id: peerIds[peerIdx] })
  const peerAnswers = answers?.filter((a) => a.peer_id === peerIds[peerIdx])

  if (!peer) return null

  return (
    <>
      {peer.id === user?.id || (
        <Paper p="sm" withBorder>
          <UserLine user={peer} />
        </Paper>
      )}
      {questions.map((q) => (
        <QuestionAnswer
          key={q.id}
          question={q}
          answer={peerAnswers.find((a) => a.question_id === q.id) as TSurveyAnswer}
        />
      ))}
      {peerIds.length > 1 && (
        <Group justify="space-between" mt="sm">
          <Button variant="navy" onClick={() => setPeerIdx(peerIdx - 1)} disabled={peerIdx == 0}>
            {t("Previous")}
          </Button>
          <Button variant="navy" onClick={() => setPeerIdx((peerIdx + 1) % peerIds.length)}>
            {t("Next")} ({peerIdx + 1} / {peerIds.length})
          </Button>
        </Group>
      )}
    </>
  )
}
